import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { map } from 'rxjs/operators'; //.pipe(map(res => res.json()));
import { BehaviorSubject, forkJoin, Observable, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { catchError, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { concat } from 'rxjs';
import { toArray } from 'rxjs/operators';
@Injectable()
export class PeticionesService {
	public url: string;
	public urlPaginaEcodeli: string;
	public urlModuloVtas: string;
	public urlCompras: string;
	public urlHostGator: string;
	public urlEcodeli: string;
	public urlEcodeliP: string;
	public urlVtex: string;
	public urlPruebasPhp: string;
	public urlAromia: string;
	public urlAnexoMov: string;
	public urlLogoMov: string;
	public urlTiendaEcodeli: string;
	public urlleads: string;
	public urlAltaOperarios: string
	public urlMP: string;
	public urlPhpAltaClientes: string;
	public urlPhpOrdenCompra: string;
	public rutaApiV2: string;
	public urlAnexoBanner: string;
	public urlDeleteBanner: string;
	public urlAnexoComodato: string;
	public urlAnexoComodatoRev: string;
	public urlEmailEcommerce: string;
	public urlLogoDescuento: string;
	public urlApiCliente: string;
	public urlCP: string;
	public urlUdp: string;
	public urlMeilisearch: string;
	public urlTokenEcommerce: string;
	public urlEnviarCupon: string;
	public urlResetPassword: string;

	public urlAws:string ;
	public urlGetTknML:string;
	/***********variables para mostrar menu */
	private menuSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
	public menu$: Observable<boolean> = this.menuSubject.asObservable();
	public mostrarMenu: boolean = true;
	private sendinblue_key: string = "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";
	private apiUrlMun = 'https://api.tau.com.mx/dipomex/v1/colonias';
	private apiKeyMun = '632b37bbdf3ddcb38ccdbe761cb0b243befb12ae';
	/* 
	 * ambientes para probar la api de vtex
	 * vtexcommercestable or vtexcommercebeta
	 */

	constructor(private _http: HttpClient, router: Router, private localSt: LocalStorageService) {
		/* console.log(environment.apiUrl)
		console.log(router.url) */
		this.urlAltaOperarios = 'https://clean.ecodeli-negocio.com/ApiRest/APIEncuestas/v1/Encuestas/';
		//this.urlAltaOperarios = 'https://www.limpiezamexico.mx/ApiRest/APIEncuestas/v1/Encuestas/';
		 
		this.urlModuloVtas = "https://clean.ecodeli-negocio.com/ApiRest/APIModuloVtas/v1/ModuloVtas/"
		this.url = "https://jsonplaceholder.typicode.com/posts";
	 
		this.urlPaginaEcodeli = "https://clean.ecodeli-negocio.com/ApiRest/APIPaginaWeb/v1/PaginaEcodeli/";
 
		this.urlCompras = "https://clean.ecodeli-negocio.com/ApiRest/APIComprasComercial/v1/ComprasComercial/";
		this.urlHostGator = "https://www.ecodeli.com.mx/";
		this.urlEcodeli = "https://www.ecodeli.com/"; 

		this.urlEcodeliP = "https://clean.ecodeli-negocio.com/ApiRest/APIEcodeliPremia/v1/EcodeliPremia/";
		this.urlVtex = "https://rubbermaidcedimx.vtexcommercestable.com.br/"
		//this.urlPruebasPhp= "http://localhost/localServer/"
		this.urlPruebasPhp = "https://www.ecodeli.com/email_leads.php";
		this.urlTiendaEcodeli = "https://www.ecodeli.com/api_shopify_ecodeli.php";
		this.urlAnexoMov = "https://www.ecodeli.com/anexoSolicitud_Comodato.php";
		this.urlLogoMov = "https://www.ecodeli.com/anexoLogo_Lead.php"
		this.urlAromia = "https://www.ecodeli.com/api_shopify.php";
		this.urlleads = 'https://clean.ecodeli-negocio.com/ApiRest/APIPaginaIndustrial/v1/paginaIndustrial/';
		this.mostrarMenu = this.localSt.retrieve('MostrarMenu') ? this.localSt.retrieve('MostrarMenu') : true;
		this.urlMP = "https://www.ecodeli.com/api_mp.php";
		this.urlLogoDescuento = "https://www.ecodeli.com/AnexoDescuento_Partner.php";
		this.urlAnexoBanner = "https://www.ecodeli.com/Anexos_Baners.php";
		this.urlDeleteBanner = "https://www.ecodeli.com/delete_Baners.php";
		this.urlAnexoComodatoRev = "https://www.ecodeli.com/anexoEvidencia_ComodatoRev.php"
		this.urlAnexoComodato = "https://www.ecodeli.com/anexoEvidencia_Comodato.php"
		this.urlPhpAltaClientes = "https://www.ecodeli.com/anexoAltaCliente.php";
		this.urlPhpOrdenCompra = "https://www.ecodeli.com/archivoOrdenCompra.php";
		this.urlGetTknML="https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/getTknML.php"

		this.rutaApiV2 = "https://clean.ecodeli-negocio.com/ApiRest/ApiEcodeliComercial/v2/PaginaEcodeli/";

		this.urlCP = "https://www.ecodeli.com/api_codigo_postal.php"
		this.urlUdp = "https://www.ecodeli.com/upd.php"
		this.urlEmailEcommerce = "http://localhost/envio_correos/enviar_correo.php"

		this.urlMeilisearch = "https://ms-cc01586a47d6-25535.nyc.meilisearch.io/indexes/art_index/search";
		this.urlTokenEcommerce = "https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/obtener_token.php"
		this.urlEnviarCupon = "https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/enviar_whatsapp_retoma_carrito.php"
		this.urlResetPassword = "https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/api_reset_password.php"
		/* this.url	EmailEcommerce = "https://www.ecodeli.com/enviar_correo.php" */
		this.urlAws = "https://2hq1ih7urh.execute-api.us-east-1.amazonaws.com/default/hello-gw"
	}
	/**MOSTRAR OCULTAR MENU**/
	getMostrarMenu(): boolean {
		console.log('entra a menu')
		console.log(this.mostrarMenu)
		this.mostrarMenu = this.localSt.retrieve('MostrarMenu') ? this.localSt.retrieve('MostrarMenu') : true;
		return this.mostrarMenu;
	}
	setMostrarMenu(valor: boolean) {
		this.mostrarMenu = valor == false ? valor : true;
		this.localSt.store('MostrarMenu', this.mostrarMenu);
		console.log('entra a mostrar menu')
		console.log(this.mostrarMenu)
		this.menuSubject.next(this.mostrarMenu);
	}

	/***********************/
	/** fin prueba **/
	/**servicio para modulo cotizador */
	getCotizador(objModulo: any): Observable<any> {
		return this._http.post(this.urlEcodeliP + 'sp_ModVentas_Cotizador', objModulo);
	}

	getPrueba() {
		return 'Hola Mundo';
	}

	getArticulos(): Observable<any> {
		return this._http.get(this.url);
	}

	getModuloVtas(objModulo: any): Observable<any> {
		return this._http.post(this.urlModuloVtas + 'sp_ModuloVtas', objModulo);
	}

	getApiCompras(objModulo: any): Observable<any> {
		return this._http.post(this.urlCompras + 'sp_ObjMix', objModulo);
	}
	getApiCompras_ecodeli_premia(objModulo: any): Observable<any> {
		return this._http.post(this.urlEcodeliP+ 'sp_ObjMix', objModulo);
	}

	getApiComprasGral(objModulo: any, sp: string): Observable<any> {
		return this._http.post(this.urlCompras + sp, objModulo);
	}

	getApiComprasScordCardReportes(objModulo: any): Observable<any> {
		return this._http.post(this.urlCompras + 'sp_ScordCardReportes', objModulo);
	}

	getApiComprasScordCardJefe(objModulo: any): Observable<any> {
		return this._http.post(this.urlCompras + 'sp_ScordCardVendedor_Jefes', objModulo);
	}
	getApiComprasScordCardVendedor(objModulo: any): Observable<any> {
		return this._http.post(this.urlCompras + 'sp_ScordCardVendedor', objModulo);
	}
	getApiEPScordCardVendedor(objModulo: any): Observable<any> {
		return this._http.post(this.urlEcodeliP + 'sp_ScordCardVendedor', objModulo);
	}
	getApiComprasScordCard(objModulo: any): Observable<any> {
		console.log(objModulo)
		console.log(this.urlCompras + 'sp_ScordCard');
		return this._http.post(this.urlCompras + 'sp_ScordCard', objModulo);
	}
	getApiEPScordCard(objModulo: any): Observable<any> {
		console.log(objModulo)
		console.log(this.urlEcodeliP + 'sp_ScordCard');
		return this._http.post(this.urlEcodeliP + 'sp_ScordCard', objModulo);
	}
	getApiComprasPedidos(objModulo: any): Observable<any> {
		return this._http.post(this.urlEcodeliP + 'sp_ModVentas_Pedidos', objModulo);
	}

	getVentasMovimientos(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'getVentasMovimientos', objModulo);
	}
	getpagViejitaPlantillas(objModulo: any, accion: string): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + accion, objModulo);
	}
	 getpagViejitaPlantillas_nuevo(objModulo: any, accion: string): Observable<any> {
		return this._http.post(this.urlEcodeliP + accion, objModulo);
	}
	getVentasMovimientos_p(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'getMovPendientesVendedor', objModulo);
	}
	setReActivarPedido(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'setReActivarPedido', objModulo);
	}

	getInfoCabecera(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'getInfoCabecera', objModulo);
	}
	getVentasMovimientosDetalle(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'getVentasMovimientosDetalle', objModulo);
	}
	setPedidosPorAutorizar(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'setPedidosPorAutorizar', objModulo);
	}
	setCambioCondicionPedido(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'setSolicitudCambioCondicionPedido', objModulo); //setCambioCondicionPedido
	}

	getCondicionContado(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'getCondicionContado', objModulo);
	}

	setAdjuntoOrdenCompra(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'setAdjuntoOrdenCompra', objModulo);
	}

	dropPedido(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'dropPedido', objModulo);
	}

	getExistenciasAlm(objModulo: any): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + 'getDisponibleXAlmacen', objModulo);
	}
	getComodatos(objModulo: any, sp: string): Observable<any> {
		//console.log(this.urlPaginaEcodeli+sp) ruta anterior
		console.log(this.urlEcodeliP + sp)
		return this._http.post(this.urlEcodeliP + sp, objModulo);
	}
	getApiRetoTork(objModulo: any): Observable<any> {
		return this._http.post(this.urlCompras + 'sp_retoTork', objModulo);
	}
	getEncriptado(objModulo: any): Observable<any> {
		let rutaReal = this.urlHostGator + 'cotizadorapp/valuserN.php'
		let rutaAlterna = 'https://www.ecodelinegocio.com/enueva/cotizadorApp/valuserN.php'
		return this._http.post(rutaAlterna, JSON.stringify(objModulo));
	}

	getEcodeli(objModulo: any, strApi: string): Observable<any> {
		return this._http.post(this.urlEcodeliP + strApi, objModulo);
	}
	insertCotizacion(objModulo: any, strApi: string): Observable<any> {
		return this._http.post(this.urlEcodeliP + strApi, objModulo);
	}
	getObjCorreo(cuerpo: string, asunto: string, archivo: File, destinatario: string, remitente: string): Observable<any> {
		const formData = new FormData();
		formData.append('cuerpo', cuerpo);
		formData.append('asunto', asunto);
		formData.append('archivo', archivo);
		formData.append('remitente', remitente);
		formData.append('destinatario', destinatario);
		return this._http.post(this.urlPruebasPhp, formData);
	}

	getApiComprasComodatos(objModulo: any): Observable<any> {
		return this._http.post(this.urlCompras + 'sp_ReporteComododatos', objModulo);
	}
	/*******************CAPTURADOR*** DE** PEDIDOS***********************/
	getListaPrecios(objModulo: any): Observable<any> {
		return this._http.post(this.urlEcodeliP + 'sp_PreciosCapturador', objModulo);
	}
	setPedido(objModulo: any): Observable<any> {
		return this._http.post(this.urlEcodeliP + 'sp_Set_Pedido', objModulo);
	}

	mostrarCotizaciones(objModulo: any, sp: string): Observable<any> {
		return this._http.post(this.urlEcodeliP + sp, objModulo);
	}

	/**************apify*******google**************prospectos*********************/
	getProspectos_apify_actId(objParams: any): Observable<any> {

		const token = 'apify_api_Mt9hS5TFwzoOXlfIHukCu8YoteOFIV0kiLmL'; // remplaza por tu token
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`,
			'Content-Type': 'application/json'
		});

		return this._http.post('https://api.apify.com/v2/acts/nwua9Gu5YrADL7ZDj/runs', objParams, { headers });
	}
	getProspectos_apify(id: string): Observable<any> {
		const token = 'apify_api_Mt9hS5TFwzoOXlfIHukCu8YoteOFIV0kiLmL'; // remplaza por tu token
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`
		});
		let url = 'https://api.apify.com/v2/actor-runs/' + id + '/dataset/items?waitForFinish=60'
		console.log(url)
		return this._http.get(url, { headers });
	}
	getEstatus_apify(id: string): Observable<any> { // Elimina actId
		const token = 'apify_api_Mt9hS5TFwzoOXlfIHukCu8YoteOFIV0kiLmL';// Reemplaza con tu token
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token}`
		});
		let url = 'https://api.apify.com/v2/actor-runs/' + id + '?fields=status'; // Corregido
		console.log(url);
		return this._http.get(url, { headers });
	}
	/*******************VTEX************************************/
	getVtex(strApi: string): Observable<any> {

		let headers = new HttpHeaders();
		/*headers = headers.set("Access-Control-Allow-Origin", "*");
		headers = headers.set("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
		headers = headers.set("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type,     Accept, x-client-key, x-client-token, x-client-secret, Authorization");
		*///headers = headers.set("Origin", "https://www.ecodeli.com");
		headers = headers.set('Content-Type', 'application/json; charset=utf-8');
		headers = headers.set('Accept', 'application/json');
		headers = headers.set('X-VTEX-API-AppKey', 'vtexappkey-rubbermaidcedimx-LGJYZK');
		headers = headers.set('X-VTEX-API-AppToken', 'QOKAMMFYUYXKJFWNKSMOMREWHVPTTEJPSHWXIRNAUOQGBRHWEBLGSQUOGPGVLWPCVVAXMJZFSZGIHEGFILSALQTWWGTLDMWZJKLJQGHDQPEWKTKMIUXSPYWIAZIBOKQZ');

		let url = `${this.urlVtex + strApi}` //en produccion debe ser urlVtex +strApi

		const requestOptions = { headers: headers };

		return this._http.get(url, requestOptions); //requestOptions
	}
	putVtex(strApi: string, param: any): Observable<any> {
		let headers = new HttpHeaders();
		headers = headers.set("Access-Control-Allow-Origin", "*");
		headers = headers.set("Access-Control-Allow-Methods", "GET,HEAD,OPTIONS,POST,PUT");
		headers = headers.set("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type,     Accept, x-client-key, x-client-token, x-client-secret, Authorization");

		headers = headers.set('Content-Type', 'application/json; charset=utf-8');
		headers = headers.set('Accept', 'application/json');
		headers = headers.set('X-VTEX-API-AppKey', 'vtexappkey-rubbermaidcedimx-LGJYZK');
		headers = headers.set('X-VTEX-API-AppToken', 'QOKAMMFYUYXKJFWNKSMOMREWHVPTTEJPSHWXIRNAUOQGBRHWEBLGSQUOGPGVLWPCVVAXMJZFSZGIHEGFILSALQTWWGTLDMWZJKLJQGHDQPEWKTKMIUXSPYWIAZIBOKQZ');
		let url = `${strApi}` //en produccion debe ser urlVtex +strApi

		const requestOptions = { headers: headers };

		//let param ={'quantity' :2}
		return this._http.put(url, param, requestOptions); //requestOptions
	}
	getVtex_php(strApi: string): Observable<any> {

		return this._http.get(this.urlEcodeli + 'api_vtex.php');

	}
	putVtex_php(strApi: string, param: any): Observable<any> {
		console.log(param);
		return this._http.post(this.urlEcodeli + 'api_vtex_Put.php', JSON.stringify(param));

	}
	getVtexEcodeli(objModulo: any): Observable<any> {
		return this._http.post(this.urlCompras + 'SP_VTEX', objModulo);
	}

	/************************FIN VTEX***************************/

	//Metodo para subir archivos PDF
	uploadFilePDF(archivo: any) {
		return this._http.post(`${this.urlEcodeli + '/PDF_Comodatos_Prueba/'}subirArchivos.php`, JSON.stringify(archivo));
	}
	subirArchivo(archivo: File): Observable<any> {
		let apiUrl = 'https://www.ecodeli.com/anexoConvenio_Politica.php';
		const formData = new FormData();
		formData.append('archivo', archivo); // 'archivo' es el nombre esperado en PHP

		return this._http.post(apiUrl, formData);
	}
	getAlmacenes(): Observable<any> {
		return this._http.get(this.urlPaginaEcodeli + 'getAlmacenes');
	}

	getOrders(objModulo: any): Observable<any> {
		return this._http.post(this.urlAromia + '?financial_status=paid', objModulo);
	}

	/* --------------Api tienda Ecodeli----------- */
	getOrdersEcodeli(objModulo: any): Observable<any> {
		return this._http.post(this.urlTiendaEcodeli + '?financial_status=paid', objModulo);
	}

	/**--------------API MERCADO PAGO ----------------------------**/
	setPAgo(form: any): Observable<any> {
		return this._http.post(this.urlMP, form);
	}
	/* ----------------------Comodatos----------------------------- */
	getLineas(objModulo: any, strApi: string): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + strApi, objModulo);
	}

	getLineasComodatos(objModulo: any, strApi: string): Observable<any> {
		return this._http.post(this.urlEcodeliP + strApi, objModulo);
	}

	setAnexMov(objModulo: any): Observable<any> {
		return this._http.post(this.urlAnexoMov, objModulo);
	}
	sp_Leads(objLogin: any): Observable<any> {
		return this._http.post(this.urlleads + 'sp_Leads', objLogin);
	}
	sp_Contactame(objLogin: any): Observable<any> {
		return this._http.post(this.urlleads + 'sp_Contactame', objLogin);
	}
	/* llenar datos con codigo postal */
	getAllSATCP(objLogin: any): Observable<any> {
		return this._http.post(this.urlAltaOperarios + 'getAllSATCP', objLogin);
	}
	uploadFiles(formData: FormData) {
		return this._http.post<any>(this.urlPhpAltaClientes, formData);
	}
	uploadContrato_Comodato(formData: FormData) {
		let url = "https://www.ecodeli.com/anexoContrato_Comodato.php";
		console.log('envia contrato')
		return this._http.post<any>(url, formData);
	}
	uploadOrdenCompra(formData: FormData) {
		return this._http.post<any>(this.urlPhpOrdenCompra, formData);
	}

	uploadPagare(ruta, formData: FormData) {
		return this._http.post<any>(ruta, formData);
	}

	setAnexMov1(objModulo: any): Observable<any> {
		console.log(objModulo)
		return this._http.post(this.urlLogoMov, objModulo);
	}

	getClienteDatos(objModulo: any, sp: string): Observable<any> {
		return this._http.post(this.urlPaginaEcodeli + sp, objModulo);
	}

	getClienteFacturas(objModulo: any, sp: string): Observable<any> {
		//let url_fact = "https://www.cleanclean.mx/ApiRest/ApiEcodeliComercial/v2/PaginaEcodeli/"; //getconsultarFacturas

		let url_fact = this.rutaApiV2;
		return this._http.post(url_fact + sp, objModulo);
	}
	makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
		return new Promise((resolve, reject) => {
			var formData: any = new FormData();
			var xhr = new XMLHttpRequest();

			for (var i = 0; i < files.length; i++) {
				formData.append('uploads[]', files[i], files[i].name);
				xhr.onreadystatechange = function () {
					if (xhr.readyState == 4) {
						if (xhr.status == 200) {
							resolve(JSON.parse(xhr.response));
						} else {
							reject(xhr.response);
						}
					}
				};
			}
			xhr.open("POST", url, true)
			xhr.send(formData)
		});

	}
	makeFileRequestMinuta(url: string, params: Array<string>, formData: FormData): Promise<any> {
		return new Promise((resolve, reject) => {
			const xhr = new XMLHttpRequest();
			// Configurar la petición AJAX
			xhr.onreadystatechange = function () {
				if (xhr.readyState == 4) {
					if (xhr.status == 200) {
						resolve(JSON.parse(xhr.response));
					} else {
						reject(xhr.response);
					}
				}
			};

			// Enviar la petición con FormData
			xhr.open("POST", url, true);
			xhr.send(formData);
		});
	}

	detalleArticulo(objModulo: any, sp: string): Observable<any> {
		return this._http.post(this.rutaApiV2 + sp, objModulo);
	}

	setAnexoComotado(objModulo: any): Observable<any> {
		return this._http.post(this.urlAnexoComodatoRev, objModulo);
	}

	setAnexoComotadoRev(objModulo: any): Observable<any> {
		return this._http.post(this.urlAnexoComodato, objModulo);
	}

	/* ------------------------------Obtener codigos postales------------------------------ */

	getCp(zipCode: string): Observable<any> {
		let url_cp = 'https://sepomex.icalialabs.com/api/v1/zip_codes?per_page=200'
		return this._http.get<any>(`${url_cp}&zip_code=${zipCode}`).pipe(
			catchError(this.handleError)
		);
	}

	private handleError(error: HttpErrorResponse) {
		console.error('Error en la API:', error);
		return throwError('Error al obtener datos. Intente de nuevo más tarde.');
	}

	/*------------------------aplazo-------------------api */
	getTokenApz(objModulo: any): Observable<any> {
		let urlAplazo = 'https://www.ecodeli.com/api_aplazo.php'
		let objParam = {
			"apiToken": "00aaaafe-76b8-49d0-aee3-88109507fef8",
			"merchantId": "11571", "MerchantURL": "https://www.ecodeli.com"
		}

		/**datos de prueba */
		/** 
		 * { "apiToken":"4413ab01-0d48-4ddc-be36-fccca99f3664",
		"merchantId": "2581" }
		   **/
		return this._http.post(urlAplazo, objParam);
	}
	getTokenApz_partner(objModulo: any): Observable<any> {
		let urlAplazo = 'https://www.ecodeli.com/api_aplazo_partner.php'
		let objParam = {
			"apiToken": "4413ab01-0d48-4ddc-be36-fccca99f3664",
			"merchantId": "2581"
		}
		//datos de producción
		/*{ "apiToken":"00aaaafe-76b8-49d0-aee3-88109507fef8",
		  "merchantId": "11571" , "MerchantURL":"https://www.ecodeli.com"
			}*/

		/**datos de prueba */
		/** 
		 * { "apiToken":"4413ab01-0d48-4ddc-be36-fccca99f3664",
		"merchantId": "2581" }
		   **/
		return this._http.post(urlAplazo, objParam);
	}

	setLoanRequestApz(objModulo: any): Observable<any> {
		let urlAplazo = 'https://www.ecodeli.com/api_aplazo_loan.php' //https://www.ecodeli.com/
		console.log(urlAplazo)
		console.log(objModulo)
		return this._http.post(urlAplazo, objModulo);
	}
	setLoanRequestApz_partner(objModulo: any): Observable<any> {
		let urlAplazo = 'https://www.ecodeli.com/api_aplazo_loan_partner.php' //https://www.ecodeli.com/
		console.log(urlAplazo)
		console.log(objModulo)
		return this._http.post(urlAplazo, objModulo);
	}


	sendEmail(data: any): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		return this._http.post<any>(this.urlEmailEcommerce, data, { headers });
	}
	/*
	  sendinblue(to: string,name:string,  content: string): Observable<any> {
		let api_url = "https://api.brevo.com/v3/smtp/email";
		const headers = new HttpHeaders({
		  'accept': 'application/json',
		  'api-key': this.sendinblue_key,
		  'content-type': 'application/json'
		});
		// Cuerpo del correo (puedes personalizarlo más según sea necesario)
		const emailBody = {
		  sender: {
			name: "Ecodeli Comercial",
			email: "info@ecodeli.com.mx"
		  },
		  to: [
			{
			  email: to,
			  name: name
			}
		  ],
		  subject: "Confirmación de Pedido",
		  htmlContent: content
		};
		return this._http.post(api_url, emailBody, { headers });
	  }
	*/
	sendinblue(to: string, name: string, content: string): Observable<any> {
		const apiUrl = "https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/send_email_negocioB.php";
		//"https://www.ecodeli.com/send_email_negocio.php";// 'http://tu-servidor.com/send_email_negocio.php'; // URL de tu servidor PHP
		const emailData = {
			to: to,
			name: name,
			content: content
		};
		console.log(emailData)

		return this._http.post(apiUrl, emailData);
	}

		sendinblueEmail(to: string, name: string, content: string,subject:string): Observable<any> {
		const apiUrl = "https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/send_email_negocioC.php";
		//"https://www.ecodeli.com/send_email_negocio.php";// 'http://tu-servidor.com/send_email_negocio.php'; // URL de tu servidor PHP
		const emailData = {
			to: to,
			name: name,
			content: content,
			subject:subject
		};
		console.log(emailData)

		return this._http.post(apiUrl, emailData);
	}

	/*  sendIA(body:any):Observable<any>{
	   const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   
	   return this._http.post(this.urlIA, body, { headers });
	 } */

	sendIA(body: string): Observable<any> {
		const promp = {
			"prompt": body + ""
		};
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		const url = 'https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/api_geminiAI.php';
		return this._http.post(url, promp, { headers });
	}

	getDatosDesdeJson(parte: string) {
		return this._http.get<any[]>('assets/EstadosMunicipios/municipios_mexico_parte' + parte + '.json');
	}
	getEstados() {
		return this._http.get<any[]>('assets/EstadosMunicipios/estados_con_archivo.json');
	}

	/*   getbuscarLugares(objDatos: { lat: number; lng: number; radio: number;keyword?: string; tipo?: string,next_page_token?: string; }) {
		let headers = new HttpHeaders()
		.set('Content-Type', 'application/json; charset=utf-8')
		.set('Accept', 'application/json');
		let params = new HttpParams()
		  .set('location', `${objDatos.lat},${objDatos.lng}`)
		  .set('radius', objDatos.radio.toString())
		  .set('key', this.apiKeyMaps);
		if (objDatos.tipo != "") {
			params = params.set('type', objDatos.tipo);
			}
			if (objDatos.keyword!="") {
			params = params.set('keyword', objDatos.keyword);
			}
		return this._http.get(this.UrlMaps, { params });
	  }
	 */
	getbuscarLugares(body: {
		lat: number;
		lng: number;
		radio: number;
		keyword?: string;
		tipo?: string;
		next_page_token?: string;
	}): Observable<any> {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		const url = 'https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/api_mapsLoc.php'; // Ruta al PHP
		return this._http.post(url, body, { headers });
	}
	getPlaceDetails(place_id: string): Observable<any> {
		let body = { place_id: place_id }
		const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
		const url = 'https://clean.ecodeli-negocio.com/ApiRest/Api_negocio/api_mapsLoc_detail.php'; // Ruta donde tienes tu PHP

		return this._http.post(url, body, { headers });
	}

	/*   getPlaceDetails(placeId: string): Observable<any> {
		const url = `${this.UrlDetailsMaps}?place_id=${placeId}&key=${this.apiKeyMaps}`;
		return this._http.get(url);
	  } */

	getColonias(id_estado: string, id_mun: string): Observable<any> {
		const headers = new HttpHeaders().set('APIKEY', this.apiKeyMun);
		const params = new HttpParams()
			.set('id_estado', id_estado)
			.set('id_mun', id_mun);

		return this._http.get(this.apiUrlMun, { headers, params });
	}
	getEstadosCep(id_estado: string, id_mun: string): Observable<any> {
		const headers = new HttpHeaders().set('APIKEY', this.apiKeyMun);
		const params = new HttpParams()
			.set('id_estado', id_estado)
			.set('id_mun', id_mun);

		return this._http.get(this.apiUrlMun, { headers, params });
	}

	getURLceomex(url: string): Observable<any> {
		const headers = new HttpHeaders().set('APIKEY', this.apiKeyMun);
		const params = new HttpParams()
		return this._http.get(url, { headers, params });
	}

	getMailiSearch(search: string, limit: number): Observable<any> {
		let body = { "q": search, "limit": limit, "showRankingScore": true, "rankingScoreThreshold": 0.75 }

		const token_ms = '1e9a674e91b8fc509bb7b9f881421e6890a512a1379b249496f1f6d38ec8996e'
		const headers = new HttpHeaders({
			'Authorization': `Bearer ${token_ms}`,
			'Content-Type': 'application/json'
		});
		return this._http.post(this.urlMeilisearch, body, { headers });
	}

	getLogisticaPlaneador(objModulo: any): Observable<any> {
		// let urlCompras2="https://www.cleanclean.mx/ApiRest/ApiComprasComercial_prueba/v1/ComprasComercial/";
		return this._http.post(this.urlCompras + 'sp_Logistica_Planeador', objModulo).pipe(
			timeout(120000), // aumenta el tiempo de espera a 2 minutos (120000 ms)
			catchError(error => {
				return throwError(error); // maneja el error si la petición expira
			}));
 
	}
	

	public ejecutarSPPorLotes_compras(body: any, inicio: number, fin: number, tamañoLote: number): Observable<any[]> {
  const lotes: Observable<any>[] = [];

  // Dividir el rango en lotes
  for (let i = inicio; i <= fin; i += tamañoLote) {
    const indice1 = i;
    const indice2 = Math.min(i + tamañoLote - 1, fin); // Asegurar que no exceda el límite
    

    const bodyCopia = JSON.parse(JSON.stringify(body)); // O usa structuredClone o cloneDeep
    bodyCopia.intIndice1 = indice1;
    bodyCopia.intIndice2 = indice2;
    // Agregar cada lote como una solicitud HTTP
    lotes.push(this.ejecutarSP_compras(indice1, indice2, bodyCopia));
  }

  // Ejecutar los lotes en orden, asegurándonos de que se respeten las dependencias
  return concat(...lotes).pipe(toArray());
}

private ejecutarSP_compras(indice1: number, indice2: number, body: any): Observable<any> {
  const url = `${this.urlCompras}sp_Logistica_Planeador`;
console.log(url)
  console.log(`Ejecutando SP con índices: ${indice1} - ${indice2}`);
  console.log(body)
  return this._http.post(url, body);
}

	ejecutarSPPorLotes(body: any, inicio: number, fin: number, tamañoLote: number) { 
		/*const peticiones = [];

		for (let i = inicio; i < fin; i += tamanoLote) {
			const indice1 = i;
			const indice2 = Math.min(i + tamanoLote - 1, fin); // Evitar que sobrepase el límite
			peticiones.push(this.ejecutarSP(indice1, indice2, objModulo));
		}

		// Ejecutar todas las peticiones en paralelo
		return forkJoin(peticiones); */

		const lotes: Observable<any>[] = [];

  // Dividir el rango en lotes
  for (let i = inicio; i <= fin; i += tamañoLote) {
    const indice1 = i;
    const indice2 = Math.min(i + tamañoLote - 1, fin); // Asegurar que no exceda el límite
    

    const bodyCopia = JSON.parse(JSON.stringify(body)); // O usa structuredClone o cloneDeep
    bodyCopia.intIndice1 = indice1;
    bodyCopia.intIndice2 = indice2;
    // Agregar cada lote como una solicitud HTTP
    lotes.push(this.ejecutarSP(indice1, indice2, bodyCopia));
  }

  // Ejecutar los lotes en orden, asegurándonos de que se respeten las dependencias
  return concat(...lotes).pipe(toArray());

		
	}
	private ejecutarSP(indice1: number, indice2: number, body: any) {
		const url = this.urlCompras + 'sp_Logistica_Planeador';
		//const body = { indice1, indice2 };
		body.intIndice1 = indice1;
		body.intIndice2 = indice2;
		console.log(body)
		return this._http.post(url, body);
	}

	 

	setAnexoDescuentos(objModulo: any): Observable<any> {
		return this._http.post(this.urlLogoDescuento, objModulo);
	}
	setAnexoBanner(objModulo: any): Observable<any> {
		return this._http.post(this.urlAnexoBanner, objModulo);
	}
	DeleteBanner(objModulo: any): Observable<any> {
		return this._http.post(this.urlDeleteBanner, objModulo);
	}


	getppd(objModulo: any): Observable<any> {
		return this._http.post(this.urlUdp, objModulo);
	}

	getTokenEcommerce(): Observable<any> {
		return this._http.get(this.urlTokenEcommerce)
	}
	getTokenMELI(objModulo: any): Observable<any> {
		return this._http.post(this.urlGetTknML, objModulo)
	}
    getPedidoMELI(objModulo: any): Observable<any> {
		return this._http.post(this.urlGetTknML, objModulo)
	}

	setCuponEcommerce(objModulo: any): Observable<any> {
		return this._http.post(this.urlEnviarCupon, objModulo);
	}
	
	getPedidos_rafa(strAccion:string,usuario:string, conexion:string, filtro:string):Observable<any>{
    let urlAplazo='https://clean.ecodeli-negocio.com/ApiRest/ApiEcodeliComercial/v2/PaginaEcodeli/get_MovimientosEmbarques';
    console.log(urlAplazo)
     
    let objModulo = { strAccion:strAccion, strConexion:conexion, strUsuario:usuario}
    return this._http.post(urlAplazo,objModulo);
  }
  	setTokenReset(objModulo: any): Observable<any> {
		return this._http.post(this.urlResetPassword, objModulo);
	}

	holaGet(name: string) {
    return this._http.get<{ok:boolean; message:string}>(`${this.urlAws}?name=${name}`);
  }
  holaPost(name: string) {
    return this._http.post<{ok:boolean; message:string}>(this.urlAws,{name});
  }
}






